export default {
    HOME: 'HOME',
    LOGIN: 'LOGIN',
    REGISTER: 'REGISTER',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
};
